<markant-platform-ui-card class="management-tile">
  <markant-platform-price-scale
    [price]="price"
    [servicePackage]="servicePackage"
  ></markant-platform-price-scale>
</markant-platform-ui-card>
